import { defineMessages } from 'react-intl';

const messages = defineMessages({
  heading: {
    id: 'Quadre medic heading',
    defaultMessage: 'QUADRE MÈDIC',
  },
  locationLabel: {
    id: 'Quadre medic location label',
    defaultMessage: 'UBICACIÓ: ',
  },
  locationsLabel: {
    id: 'Quadre medic locations label',
    defaultMessage: 'UBICACIONS: ',
  },
  unitLabel: {
    id: 'Quadre medic unit label',
    defaultMessage: 'UNITAT: ',
  },
  unitsLabel: {
    id: 'Quadre medic units label',
    defaultMessage: 'UNITATS: ',
  },
  coverageLabel: {
    id: 'Quadre medic coverage label',
    defaultMessage: 'COBERTURA: ',
  },
  coveragesLabel: {
    id: 'Quadre medic coverages label',
    defaultMessage: 'COBERTURES: ',
  },
  societyLabel: {
    id: 'Quadre medic society label',
    defaultMessage: 'SOCIETAT: ',
  },
  filtersHelp: {
    id: 'Quadre medic filters help',
    defaultMessage: 'Introduïu les dades del professional que esteu buscant',
  },
  searchSpecialtyLabel: {
    id: 'Quadre medic search specialty label',
    defaultMessage: 'CERCA PER ESPECIALITAT',
  },
  searchDoctorLabel: {
    id: 'Quadre medic search doctor label',
    defaultMessage: 'CERCA PER METGE',
  },
  specialtyDetailLabel: {
    id: 'Quadre medic specialty detail label',
    defaultMessage: 'Especialitat: ',
  },
  trainingLabel: {
    id: 'Quadre medic training label',
    defaultMessage: 'Formacions:',
  },
  positionLabel: {
    id: 'Quadre medic position label',
    defaultMessage: 'Càrrec: ',
  },
  incorporationYearLabel: {
    id: 'Quadre medic incorporation year label',
    defaultMessage: "Any d'incorporació a la Clínica Sant Josep: ",
  },
  reflectionTitle: {
    id: 'Quadre medic reflection title',
    defaultMessage: 'LA REFLEXIÓ',
  },
  backToList: {
    id: 'Quadre medic back to list',
    defaultMessage: 'TORNAR AL LLISTAT',
  },
  learnMore: {
    id: 'Quadre medic learn more',
    defaultMessage: 'SABER MÉS',
  },
});

export default messages;
